module.exports = __webpack_public_path__ + "static/media/icon_dg.987d5ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_dg.png
// module id = 391
// module chunks = 0 1